module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-layout",
    class: {
      'is-mobile': _vm.isMobile, 'is-android': _vm.isAndroid, 'is-ios': _vm.isIos, 'is-pc': _vm.isPc
    }
  }, [_c('div', {
    staticClass: "scroll-box",
    on: {
      "scroll": _vm.scrollTrigger
    }
  }, [_c('div', {
    staticClass: "slide-inner",
    style: ('width:' + _vm.layoutWidth)
  }, [(_vm.dataReady) ? _c('div', {
    ref: "layout"
  }, [_c('card', {
    staticClass: "card-mainInfo",
    attrs: {
      "size": _vm.productCard.size,
      "styleObject": _vm.productCard.styleObject
    }
  }, [_c('div', {
    staticClass: "showcase-circle",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('swiper', {
    attrs: {
      "slides": _vm.productCard.images
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "info",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.productCard.info) ? _c('span', {
    staticClass: "product-card-info"
  }, [_c('span', {
    staticClass: "product-card-info-text",
    domProps: {
      "innerHTML": _vm._s(_vm.productCard.info)
    }
  }), _vm._v(" "), _c('poor-tag', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })], 1) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "subInfo",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.productCard.subInfo)
    },
    slot: "content"
  })]), _vm._v(" "), _vm._l((_vm.productControls), function(cardItem, index) {
    return _c('card', {
      key: index,
      staticClass: "card-controls",
      attrs: {
        "size": cardItem.size,
        "styleObject": cardItem.styleObject
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('p', {
      staticClass: "left-title"
    }, [_vm._v(_vm._s(cardItem.leftTitle))]), _vm._v(" "), _c('p', {
      staticClass: "left-subTitle"
    }, [_vm._v(_vm._s(cardItem.leftSubTitle))]), _vm._v(" "), _c('div', {
      staticClass: "content-image",
      style: ({
        backgroundImage: 'url(' + cardItem.image + ')'
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(cardItem.info)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "subInfo",
      domProps: {
        "innerHTML": _vm._s(cardItem.subInfo)
      }
    })])])
  }), _vm._v(" "), _c('card', {
    staticClass: "card-details",
    attrs: {
      "size": _vm.productDetails.size,
      "styleObject": _vm.productDetails.styleObject
    }
  }, [_c('div', {
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v(_vm._s(_vm.productDetails.title))]), _vm._v(" "), _c('div', {
    staticClass: "card-content-fixed",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "slide-detail"
  }, [_c('ul', _vm._l((_vm.productDetails.list), function(item, index) {
    return (item.content) ? _c('li', {
      key: index,
      staticClass: "card-details-item zoom"
    }, [_c('span', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "detail-content",
      class: {
        'org-detail-link': item.title == '所属企业'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.detailContentClickHandler(item)
        }
      }
    }, [(item.title == '产品身份证' && item.productCode) ? _c('span', [_vm._v(_vm._s(item.productCode)), _c('br')]) : _vm._e(), _vm._v(" "), (item.productAuthentication == 1) ? _c('span', _vm._l((item.content), function(text, index) {
      return _c('span', {
        key: index,
        staticStyle: {
          "margin-right": "15px",
          "display": "inline-block"
        }
      }, [_vm._v(_vm._s(text))])
    })) : _vm._e(), _vm._v(" "), (item.productAuthentication != 1) ? _c('span', [_vm._v(_vm._s(item.content))]) : _vm._e()])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('card', {
    staticClass: "card-blockchain",
    attrs: {
      "size": _vm.blockchain.size,
      "styleObject": _vm.blockchain.styleObject
    }
  }, [_c('div', {
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v("\n            " + _vm._s(_vm.blockchain.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-content-fixed",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "slide-blockchain"
  }, [_c('ul', {
    staticStyle: {
      "padding": "0 0.2rem 0 0"
    }
  }, _vm._l((_vm.blockchain.list), function(item, index) {
    return (item.content) ? _c('li', {
      key: index,
      staticClass: "card-blockchain-item zoom"
    }, [_c('span', {
      staticClass: "blockchain-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "blockchain-content"
    }, [_vm._v(_vm._s(item.content))])]) : _vm._e()
  }))])])]), _vm._v(" "), (_vm.weather) ? _c('card', {
    staticClass: "card-weather",
    attrs: {
      "size": _vm.weather.size,
      "styleObject": _vm.weatherStyle
    },
    nativeOn: {
      "mousedown": function($event) {
        _vm.weatherDown($event)
      },
      "mouseup": function($event) {
        _vm.weatherUp($event)
      },
      "touchmove": function($event) {
        _vm.weatherMove($event)
      },
      "mousemove": function($event) {
        _vm.weatherMove($event)
      },
      "touchstart": function($event) {
        _vm.weatherDown($event)
      },
      "touchend": function($event) {
        _vm.weatherUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "content-image",
    style: ({
      backgroundImage: 'url(' + _vm.weather.image + ')'
    }),
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "info",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.weather.info)
    },
    slot: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "subInfo",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.weather.subInfo)
    },
    slot: "content"
  }), _vm._v(" "), (_vm.weatherAllowed) ? _c('div', {
    staticClass: "weather-more",
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v("更多")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('card', {
    staticClass: "card-qrcode",
    attrs: {
      "size": _vm.QRCode.size,
      "styleObject": _vm.QRCode.styleObject
    }
  }, [_c('div', {
    staticClass: "content-image",
    style: ({
      backgroundImage: 'url(' + _vm.QRCode.image + ')'
    }),
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "info",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.QRCode.info)
    },
    slot: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "subInfo",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.QRCode.subInfo)
    },
    slot: "content"
  })]), _vm._v(" "), _vm._l((_vm.cardList), function(cardItem, index) {
    return _c('div', {
      staticClass: "card-wrap",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickCard(index)
        }
      }
    }, [_c('card', {
      key: index,
      staticClass: "card-item-touch",
      attrs: {
        "onselectstart": "return false;",
        "cancelable": "false",
        "data-index": index,
        "size": cardItem.size,
        "styleObject": cardItem.styleObject
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickCard(index)
        }
      }
    }, [_c('div', {
      staticClass: "center-content",
      attrs: {
        "slot": "content"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickCard(index)
        }
      },
      slot: "content"
    }, [_c('span', {
      staticClass: "card-links",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickCard(index)
        }
      }
    }, [_c('div', {
      staticClass: "content-icon iconfont",
      class: cardItem.icon,
      style: (cardItem.iconUrl ? {
        backgroundImage: 'url(' + cardItem.iconUrl + ')'
      } : {})
    }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(cardItem.info))])])])])], 1)
  })], 2) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-09ca0284", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-09ca0284"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = 1055
// module chunks = 1